import { FC, useContext } from "react";

import PageLayout from "@/layout/Page";
import { WhiteLabelLayout } from "@/layout/WhiteLabel";
import FindBestPriceDetails from "@/components/FindBestPriceDetails/FindBestPriceDetails";
import GetAdvantageCard from "@/components/GetAdvantageCardCTA/GetAdvantageCardCTA";
import { ThemeSelectorContext } from "@/context/index";

const DrugDetails: FC = () => {
  const { client } = useContext(ThemeSelectorContext);

  return (
    <>
      {client && (
        <WhiteLabelLayout>
          <FindBestPriceDetails />
        </WhiteLabelLayout>
      )}
      {!client && (
        <PageLayout>
          <FindBestPriceDetails />
          <GetAdvantageCard />
        </PageLayout>
      )}
    </>
  );
};

export default DrugDetails;
